const styles = (theme) => ({
  root: {
    padding: theme.hvSpacing(0, "sm", "sm", "sm"),
    flex: "none",
  },
  textContent: {
    marginLeft: "42px",
    paddingRight: "62px",
    flex: 1,
    overflowY: "auto",
  },
});

export default styles;
